import { c as _c } from "react/compiler-runtime";
import { LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
export type TryAnotherWayProps = {
  onClick: () => void;
};

/**
 * Shown when the user has an unverified email auth method — offers "Send code to email" to go through KBA + email OTP.
 * Visibility should be controlled by the parent.
 */
export const TryAnotherWay = t0 => {
  const $ = _c(12);
  const {
    onClick
  } = t0;
  const {
    t
  } = useTranslation("idv2");
  let t1;
  if ($[0] !== t) {
    t1 = t(_temp);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-label-2 text-tertiary whitespace-nowrap fp-text" data-dd-privacy="mask">{t1} </span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp2);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onClick || $[7] !== t3) {
    t4 = <LinkButton variant="label-2" onClick={onClick} data-dd-action-name="inline-action:send-code-to-email">{t3}</LinkButton>;
    $[6] = onClick;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="flex flex-row gap-1 items-center justify-center w-full flex-wrap">{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
function _temp($) {
  return $.identify.login.noAccessMethods;
}
function _temp2($_0) {
  return $_0.identify.login.sendCodeToEmail;
}